import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('single_line_row_height_collapsable_fields');
	},
};
